<template>
  <div>
        <v-layout wrap align-center justify-center class="px-2">
            <v-flex xs12 mb-3>
                <div class=" title pa-3">
                    {{$t('mew.app.login.approval_message',{
                        app_domain:'ntefest.org'
                    })}}
                </div>
            </v-flex>
        </v-layout>
        <v-card-actions>

            <v-btn
                :class="[$vuetify.rtl ? 'ml-2' : '']"
                color="primary background--text"
                dark
                @click.stop="onCancel()"
                >{{ $t(`${eventPrefix}.btn.cancel`) }}</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
                :class="[$vuetify.rtl ? 'mx-0' : '']"
                color="primary background--text"
                dark
                @click.prevent="onConfirm()"
                >{{ $t("mew.oauth.login.domain.approve.btn") }}</v-btn
            >

        </v-card-actions>
  </div>
</template>

<script>
import rules from "@/validation";
import SocialLogin from "@/components/auth/SocialLogin"

export default {
    name:"AskAppLoginConfirmation",
    props:{
        eventPrefix: {
            type: String,
            default: 'screener'
        }
    },
    data(){
        return{
            rules,
        }
    },
    components: {
        SocialLogin
    },
    watch:{
    },
    methods:{
        onCancel(){
           this.$emit("onCancel",{});
        },
        onConfirm(){
           this.$emit("onConfirm",{});
        },

    }
}
</script>

<style>

</style>
